import styled from 'styled-components';
import { spaces, ColorsV2, getToken, sizes } from '@electricjs/arc';

const LoadingMessageBubble = styled.div`
  width: fit-content;
  padding: ${spaces.space_xs_rem} ${spaces.space_m_rem};
  margin-bottom: ${spaces.space_m_rem};
  background-color: ${getToken(ColorsV2.BACKGROUND_ALT)};
  border-radius: ${sizes.size_8_rem} ${sizes.size_8_rem} ${sizes.size_8_rem} 0;
  display: flex;
  align-items: center;
  gap: ${spaces.space_xs_rem};
`;

/**
 * LoadingMessage - Shows CopilotKit's animated loading indicator
 * Important note: This relies on the CopilotKit CSS being loaded globally for the
 * "copilotKitActivityDot" class to render the animated dots correctly.
 */
export const LoadingMessage = () => {
  return (
    <LoadingMessageBubble>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '2rem',
        }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            height: '100%',
          }}>
          <span
            className="copilotKitActivityDot"
            style={{ animationDelay: '0s' }}
          />
          <span
            className="copilotKitActivityDot"
            style={{ animationDelay: '0.2s' }}
          />
          <span
            className="copilotKitActivityDot"
            style={{ animationDelay: '0.4s' }}
          />
        </div>
      </div>
    </LoadingMessageBubble>
  );
};
